<template>
  <roe-error-message :field="design.auto_increase_applies_prior_employees">
    <roe-radio-input
      v-model="design.$model.auto_increase_applies_prior_employees"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import { AutoIncreaseMixin } from "@/components/_shared/inputs/design/_mixins";
export default {
  name: "RoeAutoIncreaseAppliesPriorEmployeesRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  mixins: [AutoIncreaseMixin],
  props: {
    design: Object
  }
};
</script>
